import { Modal, Form, Tooltip } from 'antd';
import React, { useState, useEffect } from 'react';
import { EfetuarConclusaoSla } from '@app/api/sla';
import { Button, Icon } from '@digital/ui';
import TextArea from 'antd/lib/input/TextArea';

export interface PropsModalComentario {
  id: string;
  onUpdatePage: () => any;
}

const ModalJustificativaAprovarSolicitacaoConcluirSla = (props: PropsModalComentario) => {
  const { id, onUpdatePage } = props;
  const [exibirModal, setExibirModal] = useState(false);
  const textAreaId = `textAreaId${id}`;
  const [justificativa, setJustificativa] = useState('');

  const limparCampo = () => {
    const elemento = document.getElementById(textAreaId);
    if (elemento != null) {
      document.getElementById(textAreaId).value = '';
    }
  };

  const showModal = () => {
    limparCampo();
    setExibirModal(true);
  };

  const handleCancel = () => {
    limparCampo();
    setExibirModal(false);
  };

  const handleEfetuarConclusaoSla = (e: any) => {
    EfetuarConclusaoSla(id).then(data => {
      if (data) {
        limparCampo();
        if (data.valid) {
          onUpdatePage();
        }
      }
    });
  };

  return (
    <>
      <Tooltip title="Efetua conclusão sumária do SLA, SEM APLICAR OS VALORES em nenhuma medição posterior.">
        <Button
          type="link"
          icon="files-check_file_filled2"
          confirm="Efetua conclusão sumária do SLA, SEM APLICAR OS VALORES em nenhuma medição posterior."
          onClick={() => {
            showModal();
          }}>
          Efetuar a Conclusão
        </Button>
      </Tooltip>

      <Modal
        title="Justificativa da aprovação da solicitação para concluir medição"
        className="chat-modal"
        visible={exibirModal}
        onCancel={() => {
          handleCancel();
        }}
        footer={[
          <Button key="submit" type="link" onClick={handleEfetuarConclusaoSla}>
            Enviar
          </Button>,
          <Button key="cancel" type="primary" onClick={() => handleCancel()}>
            Fechar
          </Button>,
        ]}>
        <TextArea
          name="justificativa"
          id="justificativa"
          onChange={value => {
            setJustificativa(value.currentTarget.value);
          }}
          placeholder="informe a justificativa"
          rows={3}
        />
      </Modal>
    </>
  );
};

export default ModalJustificativaAprovarSolicitacaoConcluirSla;
